import { NumberCell } from './NumberCell';
import { TextCellProps } from './TextCell';

export interface MoneyFormatProps {
    fractionDigits?: number;
}

export const MoneyCell = (props: TextCellProps & MoneyFormatProps) => <NumberCell {...props} style="currency" />;
